import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NavBar from "./NavBar";
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";

import AdminPanel from "./AdminPanel";
import AdminOrders from "./AdminOrders";
import HomePage from "./HomePage";
import UserDashboard from "./UserDashboard";
import CheckoutPage from "./CheckoutPage";
import MyOrders from "./MyOrders";
import CartPage from "./CartPage";
import ProductDetails from "./ProductDetails";
import AdminPrivateRoute from "./AdminPrivateRoute";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./TermsConditions";
import RefundCancellation from "./RefundCancellation";
import AdminCoupons from "./AdminCoupons";


function App() {
  return (
    <>
      <NavBar />

      <Routes>
        {/* Default */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/refund" element={<RefundCancellation />} />
        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Admin Login */}
        <Route path="/admin/login" element={<Login />} />

        {/* Admin Protected Routes */}
        <Route
          path="/admin"
          element={
            <AdminPrivateRoute>
              <AdminPanel />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/orders"
          element={
            <AdminPrivateRoute>
              <AdminOrders />
            </AdminPrivateRoute>
          }
        />
 <Route
  path="/admin/coupons"
  element={
    <AdminPrivateRoute>
      <AdminCoupons />
    </AdminPrivateRoute>
  }
/>

        {/* Product Details */}
        <Route path="/product/:id" element={<ProductDetails />} />

        {/* User Dashboard */}
        <Route path="/userdashboard/*" element={<UserDashboard />}>
          <Route path="products" element={<HomePage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="myorders" element={<MyOrders />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
